import * as React from 'react';
import {
    TimeZone, TournamentConstraints,
    TournamentSchedule, TournamentScheduleTime,
} from '../../../../generated/protocol';
import { Condition } from '../../form/Condition';
import { CronSchedule } from '../../form/CronSchedule';
import { FormComponentProps } from '../../form/Form';
import { FormDatePicker } from '../../form/FormDatePicker';
import { FormGroup } from '../../form/FormGroup';
import { FormInput } from '../../form/FormInput';
import { FormTransferContainer } from '../../form/FormTransferContainer';
import { SelectInput } from '../../form/SelectInput';
import { Validators } from '../../form/Validators';
import { TournamentSchedulePreview } from './TournamentSchedulePreview';
import {FeatureToggleService} from "../../../service/FeatureToggleService";

interface TournamentFlavourProps extends FormComponentProps {
    isLateReg: boolean,
    hasAddon: boolean,
    hasRebuy: boolean,
}

export class TournamentFlavourPanel extends React.Component<TournamentFlavourProps, {}> {

    constructor(props) {
        super(props);
    }

    render(): JSX.Element {
        const hasLateRegOrRebuysAddons = this.props.isLateReg || this.props.hasAddon || this.props.hasRebuy;

        return (
            <FormTransferContainer {...this.props}>
                <div className='row'>
                    <div className='col-lg-12'>
                        <div className='ibox float-e-margins'>
                            <div className='ibox-title'>
                                <h5>Flavour</h5>
                            </div>
                            <div className='ibox-content'>

                                <FormGroup className='form-group'>
                                    <label className='col-sm-2 control-label'>Randomizer Tournament</label>
                                    <div className='col-sm-10'>
                                        <FormInput type='checkbox' model='configuration.isRandomizer' disabled={hasLateRegOrRebuysAddons} />
                                    </div>
                                </FormGroup>

                                <FormGroup className='form-group'>
                                    <label className='col-sm-2 control-label'>Shootout Tournament</label>
                                    <div className='col-sm-10'>
                                        <FormInput type='checkbox' model='configuration.isShootout' disabled={hasLateRegOrRebuysAddons} />
                                    </div>
                                </FormGroup>

                            </div>
                        </div>
                    </div>
                </div>
            </FormTransferContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/TournamentFlavourPanel.tsx